import $ from 'jquery';

import {
	restCall,
	getGlobalItem,
	replaceCurlyBraces
} from '../common/utilities.js';

import { getActionsOrder } from '@builder-legacy/item/sortability/utilities';

// Import utilities
const {
	addParametersUTM,
	isDefined
} = _uo.utility;

import Modal from '../common/modal.js';

import Triggers from './triggers.js';
import Actions  from './actions.js';

import {
	updateRemoteConditionsMeta
} from '@builder-legacy/item/conditions/utilities';

class ItemHeaderMenu {
	/**
	 * Create item actions
	 *
	 * @since 0.5
	 *
	 * @return jQuery DOM element with the item actions
	 */

	constructor( itemType, integrationID, itemCode, itemId ){
		this.itemType      = itemType;
		this.integrationID = integrationID;
		this.itemCode      = itemCode;
		this.itemId        = itemId;
		this.item          = UncannyAutomator.recipe.items[ itemId ];

		return this.createItemActions();
	}

	createItemActions(){
		// Create elements
		let container     = $( '<div/>', { 'class': 'item-actions' }),
			btn           = $( '<div/>', { 'class': 'item-actions__btn' }),
			btnIcon       = $( '<uo-icon/>', { 'id': 'ellipsis-h' }),
			dropdown      = $( '<div/>', { 'class': 'item-actions__dropdown' }),
			dropdownUl    = $( '<ul/>', { 'class': 'item-actions-dropdown__ul' });

		btn.append( btnIcon );
		container.append( btn );

		// Delete
		let deleteAction  = $( '<li/>', { 'class': 'item-actions-dropdown__action item-actions-dropdown__action--danger' }),
			deleteText    = $( '<span/>' ).text( UncannyAutomator._core.i18n.delete );

		deleteAction.append( deleteText );
		dropdownUl.append( deleteAction );

		dropdown.append( dropdownUl );
		container.append( dropdown );

		// Check if it's an action
		if ( this.itemType == 'action' ) {
			// Duplicate
			const $duplicateAction = document.createElement( 'li' );
			$duplicateAction.classList.add( 'item-actions-dropdown__action' );
			$duplicateAction.innerHTML = `<span>${ UncannyAutomator._core.i18n.duplicate }</span>`;

			// Add button
			dropdownUl.get(0).appendChild( $duplicateAction );

			// Listen clicks to the button, add loading animation and do REST call to duplicate the action
			$duplicateAction.addEventListener( 'click', () => {
				// Add loading animation
				$duplicateAction.classList.add( 'item-actions-dropdown__action--loading' );

				UncannyAutomator._core.recipe.item.duplicateAction(
					this.itemId
				).catch( error => {
					// Remove loading animation
					$duplicateAction.classList.remove( 'item-actions-dropdown__action--loading' );
				} );
			} );
		}

		// Listen clicks to the open button
		btn.on( 'click', () => {
			// Evaluate if it's open
			const isOpen = container.hasClass( 'item-actions--open' );

			// Check if it's not open
			if ( ! isOpen ){
				// Open the dropdown
				container.addClass( 'item-actions--open' );

				// Listen clicks outside the dropdown
				$( document ).on( 'mouseup.uap-actions-click-outside', ( event ) => {
					if ( ! container.is( event.target ) && container.has( event.target ).length === 0 ){
						// Close dropdown
						container.removeClass( 'item-actions--open' );

						// Remove event listener to listen clicks outside the dropdown
						$( document ).off( 'mouseup.uap-actions-click-outside' );
					}
				});           
			}
			else {
				// Close dropdown
				container.removeClass( 'item-actions--open' );

				// Remove event listener to listen clicks outside the dropdown
				$( document ).off( 'mouseup.uap-actions-click-outside' );
			}
		});

		// Delete
		deleteAction.on( 'click', () => {
			if ( isDefined( this.itemId ) && UncannyAutomator._recipe.is_recipe_on && UncannyAutomator.recipe.items[ this.itemId ].isLive ){
				// Hide dropdown with options
				container.removeClass( 'item-actions--open' );

				// Create modal box
				// Read Modal.js comments for more information
				let modal = new Modal({
					title:       UncannyAutomator._core.i18n.confirmationModal.title,
					warning:     replaceCurlyBraces( UncannyAutomator._core.i18n.confirmationModal.deleteWarning, '<strong>', '</strong>' ),
					buttons: {
						cancel:  UncannyAutomator._core.i18n.cancel,
						confirm: UncannyAutomator._core.i18n.confirm,
					}
				});

				modal.setEvents({
					afterSetEvents: () => {
						modal.show();
					},
					onConfirm: () => {
						let elements        = modal.getElements();
						let confirmButton   = elements.modal.box.buttons.confirm;

						// Add loading class to button
						confirmButton.addClass( 'uap-btn--loading' ).prop( 'disabled', true );

						// Check if the action had conditions
						const actionHadConditions = UncannyAutomator.recipe.items[ this.itemId ].hasConditions;

						if ( actionHadConditions ) {
							// Remove the action from the conditions group
							const conditionsGroupID = UncannyAutomator.recipe.items[ this.itemId ].conditionsGroupID;

							// Get the conditions block
							UncannyAutomator.recipe.conditions[ conditionsGroupID ].removeAction( this.itemId );
						}

						UncannyAutomator._core.recipe.item.deleteItem(
							this.itemType,
							this.itemId,
							{
								__deprecated__ignoreValidation: true
							}
						).then( response => {
							// Destroy modal
							modal.destroy();

							// Clear the cache of tokens
							UncannyAutomator._cache.tokens = [];

							// Refresh UI
							if ( this.itemType == 'trigger' ){
								new Triggers();

								// Check if it's an anonymous recipe
								if ( UncannyAutomator._recipe.recipe_type == 'anonymous' ){
									// Render the Actions metabox again
									// We're doing this because we need to update the user selector
									new Actions();
								}
							}
							
							if ( this.itemType == 'action' || this.itemType == 'closure' ){
								if ( actionHadConditions ) {
									updateRemoteConditionsMeta( {
										onSuccess: () => {
											new Actions();
										}
									} );
								} else {
									new Actions();
								}
							}

							// Check if the recipe is still valid, if it isn't then make the recipe draft
							if ( ! UncannyAutomator.recipe.isValid ){
								UncannyAutomator.recipe.publish.statusToggle.setValue( false );
							}
						} )
						.catch( error => {
							// Destroy modal
							modal.destroy();

							// Refresh UI
							if ( this.itemType == 'trigger' ){
								new Triggers();
							}
							
							if ( this.itemType == 'action' || this.itemType == 'closure' ){
								new Actions();
							}
						} );
					},
					afterHide: function(){
						modal.destroy();
					}
				});
			}
			else {
				// Delete without warning
				if ( isDefined( this.itemId ) ){
					// Set loading to the "delete" option
					deleteAction.addClass( 'item-actions-dropdown__action--loading' );

					// Check if the action had conditions
					const actionHadConditions = UncannyAutomator.recipe.items[ this.itemId ].hasConditions;

					if ( actionHadConditions ) {
						// Remove the action from the conditions group
						const conditionsGroupID = UncannyAutomator.recipe.items[ this.itemId ].conditionsGroupID;

						// Get the conditions block
						UncannyAutomator.recipe.conditions[ conditionsGroupID ].removeAction( this.itemId );
					}

					UncannyAutomator._core.recipe.item.deleteItem(
						this.itemType,
						this.itemId,
						{
							/**
							 * @todo Remove this once the new recipe object is implemented.
							 * 
							 * `.deleteItem` does some basic validation before deleting the item, like checking whether
							 * both the item and the recipe are live. In this case, this file already does some custom
							 * validation that's more complex. For example, it checks if the action has conditions and
							 * removes it from the conditions group before deleting it. 
							 * 
							 * As `.deleteItem` can't contain that functionality until action conditions become posts,
							 * we'll leave the validation to this file and ignore the core one.
							 */
							__deprecated__ignoreValidation: true
						}
					).then( response => {
						// Clear the cache of tokens
						UncannyAutomator._cache.tokens = [];

						// Reset UI
						if ( this.itemType == 'trigger' ){
							new Triggers();

							// Check if it's an anonymous recipe
							if ( UncannyAutomator._recipe.recipe_type == 'anonymous' ){
								// Render the Actions metabox again
								// We're doing this because we need to update the user selector
								new Actions();
							}
						}
						
						if ( this.itemType == 'action' || this.itemType == 'closure' ){
							if ( actionHadConditions ) {
								updateRemoteConditionsMeta( {
									onSuccess: () => {
										new Actions();
									}
								} );
							} else {
								new Actions();
							}
						}
					} ).catch( error => {
						// Reset UI
						if ( this.itemType == 'trigger' ){
							new Triggers();
						}
						
						if ( this.itemType == 'action' || this.itemType == 'closure' ){
							new Actions();
						}
					} );
				}
				else {
					// Reset UI
					if ( this.itemType == 'trigger' ){
						new Triggers();
					}
					
					if ( this.itemType == 'action' ){
						new Actions();
					}
				}
			}
		});

		return container;
	}
}

export default ItemHeaderMenu;
